module.exports = __webpack_public_path__ + "static/media/1008975.caaa901c.png";